import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsAlertBannerDisplayed } from '../../store/ui/ui.selectors'
import { hideAlertBanner } from '../../store/ui/uiSlice'
import { isEmptyObj } from '../../utils/object'
import cross from '../genericComponents/assets/cross.svg'
import SVGIcon from '../svg/SVGIcon'
import s from './AlertBanner.less'
import { requestBrowserCmsAlertBanner } from './cms.client.requests'

const DEFAULT_BACKGROUND_COLOR = '#ffe866'

const AlertBanner = () => {
  const dispatch = useDispatch()
  const [bannerContent, setBannerContent] = useState(null)
  const shouldBannerBeDisplayed = useSelector(selectIsAlertBannerDisplayed)

  useEffect(() => {
    const fetchBannerContent = async () => {
      const alertBannerContent = await requestBrowserCmsAlertBanner()

      if (alertBannerContent !== bannerContent) setBannerContent(alertBannerContent)
    }

    fetchBannerContent()
  }, [setBannerContent])

  const onCloseButton = useCallback(() => {
    dispatch(hideAlertBanner())
  }, [])

  if (isEmptyObj(bannerContent) || !shouldBannerBeDisplayed) return <></>

  const { description, redirection, backgroundColor } = bannerContent

  return (
    <div className={s.root} style={{ backgroundColor: backgroundColor ?? DEFAULT_BACKGROUND_COLOR }}>
      {redirection ? (
        <a className={s.textContainer} href={redirection} target="_blank" rel="noreferrer">
          <span className={s.textContent}>{description}</span>
        </a>
      ) : (
        <div className={s.textContainer}>
          <span className={s.textContent}>{description}</span>
        </div>
      )}
      <div className={s.onCloseButton} onClick={onCloseButton}>
        <SVGIcon url={cross} />
      </div>
    </div>
  )
}

export default AlertBanner
